"use client";

import { useEffect } from "react";

import {
  STARTUP_STALL_ENDPOINT,
  STARTUP_STALL_TIMEOUT_MS,
  isDashboardStartupComplete,
  type StartupStallReport,
} from "@/dashboard/lib/startup-watchdog";

/**
 * Report a dashboard tab that never commits its resolved session (left on the auth spinner).
 * Arms from the root layout because the stalled commit is the one that would mark it done.
 */
export function DashboardStartupWatchdog() {
  useEffect(() => {
    if (!window.location.pathname.startsWith("/dashboard")) {
      return;
    }
    let everHidden = document.visibilityState === "hidden";
    const onVisibility = () => {
      everHidden ||= document.visibilityState === "hidden";
    };
    document.addEventListener("visibilitychange", onVisibility);
    const timer = setTimeout(() => {
      if (isDashboardStartupComplete() || !window.location.pathname.startsWith("/dashboard")) {
        return;
      }
      const report: StartupStallReport = {
        path: window.location.pathname.slice(0, 512),
        msSinceLoad: Math.round(performance.now()),
        visibility: document.visibilityState,
        everHidden,
      };
      navigator.sendBeacon?.(STARTUP_STALL_ENDPOINT, JSON.stringify(report));
    }, STARTUP_STALL_TIMEOUT_MS);
    return () => {
      clearTimeout(timer);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);
  return null;
}
